const GEOSERVER_BASE = "https://blueview.mapgeoid.com/geoserver";

/**
 * FastAPI backend (auth + users CRUD).
 * Default "" uses same origin / CRA dev proxy (package.json → localhost:8000).
 * Set REACT_APP_BACKEND_URL for a separate API host in production.
 */
export const BACKEND_API_BASE = "https://blueview.mapgeoid.com/api/v1";

/** Dashboard REST API base */
export const API_BASE = `${BACKEND_API_BASE}/dashboard`;

export const GS_WMS = `${GEOSERVER_BASE}/wms`;
export const GS_WFS = `${GEOSERVER_BASE}/wfs`;

export const GEOSERVER_CONFIG = {
  baseUrl: GEOSERVER_BASE,
  get wfsUrl() {
    return `${this.baseUrl}/wfs`;
  },
  get wmsUrl() {
    return `${this.baseUrl}/wms`;
  },
  getWfsUrlForLayer(wmsUrl) {
    if (wmsUrl) return wmsUrl.replace("/wms", "/wfs");
    return this.wfsUrl;
  },
};

export const DEFAULT_WFS_PARAMS = {
  service: "WFS",
  version: "1.0.0",
  request: "GetFeature",
  outputFormat: "application/json",
  srsName: "EPSG:4326",
};

export const WFS_BASE = DEFAULT_WFS_PARAMS;
